import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';

export default class UsedInAssignmentsTable extends Component {
  capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

  render() {
    const { data, signs, campaigns } = this.props;

    if (!data || !signs || !campaigns) {
      return null;
    }

    return (
      <div className="mt-2 ml-2 h-[164px] w-full overflow-y-auto rounded-2xl p-2 bg-white">
        <p
          className="mt-0 mb-2 text-dark-night font-[16px] poppins-bold"
          data-test="used-assignments-title"
        >
          Used in {pluralize('Assignment', data.length, true)}
        </p>
        {data.map(assignment => (
          <div key={`used-in-assignments-${assignment.id}`} className="flex space-x-2 space-y-1">
            <p className="text-dark-night max-w-[calc(100%-20px)] flex-1 truncate">
              {this.capitalize(assignment.name)}
            </p>
            <Link
              to={`/devices/${assignment.device_id}`}
              type="button"
              className=" appearance-none h-[20px] flex items-center justify-center
              w-[20px] bg-[#FF5E00] cursor-pointer"
              onClick={() => {}}
            >
              <img src="/assets/images/icons/right_arrow.svg" alt="view assignment" />
            </Link>
          </div>
        ))}
      </div>
    );
  }
}

UsedInAssignmentsTable.propTypes = {
  data: PropTypes.array,
  signs: PropTypes.array,
  campaigns: PropTypes.array,
};
